var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractiveHelpIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.617,
    height: 17.047,
    viewBox: "0 0 11.617 17.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2406",
    "data-name": "Group 2406",
    transform: "translate(-15328.178 -702.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(15328.178 702.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M3.323,64.818V59.4a1.456,1.456,0,0,1,1.225-1.532,1.433,1.433,0,0,1,1.679,1.3c.033.805.012,1.612.015,2.418v.282a1.349,1.349,0,0,1,1.2.281.643.643,0,0,0,.687.17,1.376,1.376,0,0,1,1.495.71c.035.064.067.13.088.172a4.94,4.94,0,0,1,.651,0A1.416,1.416,0,0,1,11.6,64.586c.011.887.05,1.778-.01,2.662a4.43,4.43,0,0,1-2.6,3.795,7.109,7.109,0,0,1-5.028-.067,5.091,5.091,0,0,1-1.734-1.55Q1.234,67.942.248,66.455a1.281,1.281,0,0,1,.395-1.869,2.155,2.155,0,0,1,2.438.054C3.15,64.69,3.219,64.741,3.323,64.818Z",
    transform: "translate(-0.001 -54.422)",
    fill: "#268af6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M101.8,17.88a.585.585,0,0,1,.564.322.492.492,0,0,1-.059.583c-.433.454-.875.9-1.334,1.329a.524.524,0,0,1-.725-.051.538.538,0,0,1-.044-.744c.42-.447.858-.877,1.3-1.3A.894.894,0,0,1,101.8,17.88Z",
    transform: "translate(-94.157 -16.822)",
    fill: "#268af6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M21.81,18.582a.66.66,0,0,1,.347-.489.485.485,0,0,1,.58.053c.449.425.891.86,1.312,1.313a.526.526,0,0,1-.063.739.536.536,0,0,1-.744.023q-.651-.618-1.265-1.269A1.27,1.27,0,0,1,21.81,18.582Z",
    transform: "translate(-20.52 -16.955)",
    fill: "#268af6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M5.567,68.354c-.281,0-.562.005-.842,0a.567.567,0,0,1-.585-.567.56.56,0,0,1,.571-.557q.853-.013,1.707,0a.544.544,0,0,1,.558.564.554.554,0,0,1-.566.558C6.128,68.36,5.847,68.354,5.567,68.354Z",
    transform: "translate(-3.895 -63.247)",
    fill: "#268af6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M71.407,1.415c0-.28,0-.561,0-.842A.565.565,0,0,1,71.959,0a.552.552,0,0,1,.57.554q.016.865,0,1.73a.552.552,0,0,1-.57.555.563.563,0,0,1-.551-.577C71.4,1.976,71.407,1.695,71.407,1.415Z",
    transform: "translate(-67.181 0.005)",
    fill: "#268af6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M111.213,68.374c-.281,0-.562.005-.842,0a.561.561,0,0,1-.576-.551.551.551,0,0,1,.554-.57q.865-.016,1.73,0a.55.55,0,0,1,.554.569.566.566,0,0,1-.576.552h-.842Z",
    transform: "translate(-103.3 -63.267)",
    fill: "#268af6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractiveHelpIconBlue);
export default __webpack_public_path__ + "static/media/interactive-help-icon-blue.2df00b380d932925e11217386849eaa5.svg";
export { ForwardRef as ReactComponent };